/**
 * 工单管理（workOrderManagement）模块英文映射 · 第 2 组（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/workOrderManagement/workManagement/ 下 index、indexOutsourcing、
 * indexWaterWorks 及 modules/ 下 takeOrder、WorkOrderEvaluationModal、selectNewMeter、
 * repairRegisterModal、repairPlaceModal、newMeterModal、detailModal、
 * EngineeringInstallationDetail、TearDownAndInstallDetail、TearDownAndInstallModal、
 * putOnRecord、auditModal、repairDetailModal、repairOrdersModal、workModal
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js）──
  '确定': 'OK',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '编辑': 'Edit',
  '新增': 'Add',
  '详情': 'Details',
  '操作': 'Action',
  '是': 'Yes',
  '否': 'No',
  '其他': 'Other',
  '创建时间': 'Created At',
  '创建人': 'Created By',
  '备注': 'Remark',
  '请输入备注': 'Please enter remark',
  '全部': 'All',
  '处理中': 'Processing',
  '已结束': 'Finished',
  '展开': 'Expand',
  '收起': 'Collapse',
  '上传': 'Upload',
  '上报时间': 'Report Time',
  '预约时间': 'Appointment Time',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '图片': 'Images',
  '附件': 'Attachment',
  '状态': 'Status',
  '来源': 'Source',
  '小程序': 'Mini Program',
  '公众号': 'Official Account',
  '申请人': 'Applicant',
  '申请时间': 'Application Time',
  '更新时间': 'Updated At',
  '联系电话': 'Contact Phone',
  '手机号码': 'Mobile Phone',
  '身份证号': 'ID Number',
  '区域名称': 'Area Name',
  '区域信息': 'Area Info',
  '用户地址': 'Customer Address',
  '用户信息': 'Customer Info',
  '用户编号': 'Customer No.',
  '用户姓名': 'Customer Name',
  '用户类型': 'Customer Type',
  '用户类别': 'Customer Category',
  '企业': 'Enterprise',
  '自然人': 'Natural Person',
  '身份类型': 'Identity Type',
  '紧急程度': 'Urgency',
  '操作成功': 'Operation successful',
  '请选择一条记录': 'Please select a record',
  '请选择下一节点操作人': 'Please select next node handler',
  '请选择报装类型': 'Please select application type',
  '请选择紧急程度': 'Please select urgency',
  '请选择用水类别': 'Select water usage category',
  '请选择是否以旧表机械读数结算': 'Select whether to settle by old meter mechanical reading',
  '请选择是否是否以旧表机械读数结算': 'Select whether to settle by old meter mechanical reading',
  '请输入联系人': 'Please enter contact',
  '请输入创建人电话': 'Please enter creator phone',
  '请输入用户联系电话': 'Please enter customer contact phone',
  '请输入新表编号': 'Please enter new meter No.',
  '请上传图片': 'Please upload an image',
  '请上传处理前图片': 'Please upload before photo',
  '请上传处理后图片': 'Please upload after photo',
  '请上传新表照片': 'Please upload new meter photos',
  '请上传旧表照片': 'Please upload old meter photos',
  '只能上传图片文件!': 'Only image files can be uploaded!',
  '新增成功': 'Added successfully',
  '编辑成功': 'Updated successfully',
  '现场施工照片': 'On-site Construction Photos',
  '存在必填内容未填！': 'Required fields are missing!',
  '操作失败': 'Operation failed',
  '元': 'CNY',
  '查询起始时间': 'Start time',
  '查询结束时间': 'End time',
  // ── 工单通用 ──
  '工单管理页面': 'Work Order Management',
  '工单信息': 'Work Order Information',
  '工单编号': 'Work Order No.',
  '工单类型': 'Work Order Type',
  '工单状态': 'Work Order Status',
  '工单紧急程度': 'Work Order Urgency',
  '工单联系人': 'Work Order Contact',
  '当前节点处理人': 'Current Node Handler',
  '请输入工单编号': 'Please enter work order no.',
  '请选择工单类型': 'Please select work order type',
  '请选择工单紧急程度': 'Please select work order urgency',
  '请选择状态': 'Select status',
  '创建人员': 'Creator',
  '请选择创建人员': 'Please select creator',
  '微信端游客': 'WeChat Guest',
  '换表': 'Meter Replacement',
  '故障报修': 'Fault Repair',
  '水厂报修': 'Water Plant Repair',
  '报停': 'Suspension',
  '复接': 'Reconnection',
  '销户': 'Account Cancellation',
  '用水性质变更': 'Water Use Category Change',
  '个人报装': 'Individual Installation',
  '企业报装': 'Enterprise Installation',
  '用水': 'Water Use',
  '处理信息': 'Handling Info',
  '处理描述': 'Handling Description',
  '处理成功': 'Processed Successfully',
  '处理前照片': 'Before Photo',
  '处理后照片': 'After Photo',
  '处理照片': 'Handling Photos',
  '处理人账号': 'Handler Account',
  '处理人名称': 'Handler Name',
  '处理人电话': 'Handler Phone',
  '处理人员名称': 'Handler Name',
  '处理人员账号': 'Handler Account',
  '处理人员电话': 'Handler Phone',
  '处理人员描述': 'Handler Description',
  '请选择处理人员': 'Please select handler',
  '请选择处理时间': 'Please select handling time',
  '请输入处理描述': 'Please enter handling description',
  '是否解决': 'Resolved',
  '已解决': 'Resolved',
  '未解决': 'Unresolved',
  '请选择是否解决': 'Please select whether resolved',
  '开启成功': 'Started successfully',
  '安装成功': 'Installed successfully',
  // ── 报修 ──
  '报修信息': 'Repair Report Info',
  '报修人名称': 'Reporter Name',
  '报修人电话': 'Reporter Phone',
  '报修地址': 'Repair Address',
  '报修描述': 'Repair Description',
  '报修时间': 'Report Time',
  '报修图片': 'Repair Photos',
  '报修图片:': 'Repair Photos:',
  '设备信息': 'Device Info',
  '请输入报修人名称': 'Please enter reporter name',
  '请输入报修人电话': 'Please enter reporter phone',
  '请输入报修地址': 'Please enter repair address',
  '请输入报修描述': 'Please enter repair description',
  '请输入设备信息': 'Please enter device info',
  '请输入信息': 'Please enter info',
  '请选择报修时间': 'Select report time',
  '请上传报修图片': 'Please upload repair photos',
  '修理信息': 'Repair Info',
  '修理图片:': 'Repair Photos: ',
  '修理人员电话': 'Repairer Phone',
  '修理人员描述': 'Repairer Description',
  '请输入修理人员电话': 'Please enter repairer phone',
  '请输入修理人员描述': 'Please enter repairer description',
  '系统用户': 'System User',
  '非系统用户': 'Non-system User',
  '请选择系统用户信息': 'Please select a system user',
  '选择用户': 'Select Customer',
  '请选择用户！': 'Please select a customer!',
  '用户电话': 'Customer Phone',
  '用户电话查询': 'Search by customer phone',
  '用户编号模糊查询': 'Search by customer no.',
  '用户姓名模糊查询': 'Search by customer name',
  '用户地址模糊查询': 'Search by customer address',
  '接单': 'Accept',
  '接单确认': 'Acceptance Confirmation',
  '接单成功': 'Order accepted successfully',
  '驳回': 'Reject',
  '驳回确认': 'Rejection Confirmation',
  '已驳回': 'Rejected',
  '归档': 'Archive',
  '归档确认': 'Archive Confirmation',
  '归档成功': 'Archived successfully',
  '通过': 'Approve',
  '审核意见': 'Review Opinion',
  '请选择审批意见': 'Please select approval opinion',
  '是否归档': 'Archive',
  '请选择是否归档': 'Select whether to archive',
  '是否结束': 'Finished',
  '请选择是否结束': 'Select whether finished',
  '是否补录': 'Supplementary Entry',
  '请选择是否补录': 'Select whether supplementary entry',
  '是否换表': 'Meter Replacement',
  '不换表': 'No Replacement',
  '请选择是否换表': 'Select whether to replace meter',
  '备注信息': 'Remarks',
  '请输入备注信息': 'Please enter remark',
  '是否委托': 'Entrusted or Not',
  '委托书': 'Letter of Authorization',
  '被委托人身份证正反面': 'Entrusted Person ID Card (Front & Back)',
  // ── 换表 ──
  '新表具信息': 'New Meter Info',
  '新表编号': 'New Meter No.',
  '新表厂商': 'New Meter Manufacturer',
  '新表口径': 'New Meter Caliber',
  '新表类型': 'New Meter Type',
  '新表照片': 'New Meter Photos',
  '新表图片': 'New Meter Photos',
  '新表表端累计读数(m³)': 'New Meter Cumulative Reading (m³)',
  '新表开始计费读数(m³)': 'New Meter Billing Start Reading (m³)',
  '旧表信息': 'Old Meter Info',
  '旧表具信息': 'Old Meter Info',
  '旧表编号': 'Old Meter No.',
  '旧表照片': 'Old Meter Photos',
  '旧表图片': 'Old Meter Photos',
  '旧表机械读数(m³)': 'Old Meter Mechanical Reading (m³)',
  '水表厂家': 'Meter Manufacturer',
  '水表厂商': 'Water Meter Manufacturer',
  '水表用途': 'Water Meter Purpose',
  '水表照片': 'Meter Photos',
  '水表无反应（黑屏，无法激活）': 'Water meter unresponsive (black screen, cannot activate)',
  '口径': 'Caliber',
  '表具信息': 'Meter Info',
  '表编号': 'Meter No.',
  '表类型': 'Meter Type',
  '表口径': 'Meter Caliber',
  '册号': 'Register No.',
  '表编号模糊查询': 'Search by meter no.',
  '表安装地址': 'Meter Installation Address',
  '表开始计费读数(m³)': 'Billing Start Reading (m³)',
  '表计费起始读数': 'Billing Start Reading',
  '表计费起始读数(m³)': 'Meter Billing Start Reading (m³)',
  '末次上报日期': 'Last Report Date',
  '末次上报结算流量(m³)': 'Last Reported Settlement Flow (m³)',
  '末次上报结算余额(元)': 'Last Reported Settlement Balance (CNY)',
  '换表原因': 'Meter Replacement Reason',
  '换表原因描述': 'Meter Replacement Reason Description',
  '换表操作': 'Meter Replacement Operation',
  '周期性换表': 'Periodic Meter Replacement',
  '故障换表': 'Faulty Meter Replacement',
  '基表问题': 'Base Meter Problem',
  '计量问题': 'Metering Problem',
  '阀门故障': 'Valve Fault',
  '基表爆裂': 'Base Meter Burst',
  '电子问题': 'Electronic Problem',
  '不上传数据': 'No Data Upload',
  '磁干扰': 'Magnetic Interference',
  '缺电': 'Power Shortage',
  '是否以旧表机械读数结算': 'Settle by Old Meter Mechanical Reading',
  '是否旧表机械读数结算': 'Settle by Old Meter Mechanical Reading',
  '请选择换表原因': 'Please select meter replacement reason',
  '请输入换表原因描述': 'Please enter meter replacement reason description',
  '请输入旧表机械读数': 'Please enter old meter mechanical reading',
  '请输入新表开始计费读数': 'Please enter new meter billing start reading',
  '请输入起始读数': 'Please enter start reading',
  '请选择新表': 'Please select a new meter',
  '请选择新表数据': 'Please select new meter data',
  '选择新表': 'Select New Meter',
  '添加设备信息': 'Add Device Info',
  '请选择添加设备信息': 'Please add device info',
  '绑定新表': 'Bind New Meter',
  '绑定新表成功': 'New meter bound successfully',
  '获取表类型失败': 'Failed to get meter type',
  '该表编号不能使用!': 'This meter No. is unavailable!',
  '请选择表编号!': 'Please select meter No.!',
  '请选择表类型': 'Select meter type',
  '请选择表类型！': 'Please select meter type!',
  '请选择表口径': 'Please select meter caliber',
  '请选择表口径！': 'Please select meter caliber!',
  '请输入表编号': 'Please enter meter No.',
  '请输入册号': 'Please enter register No.',
  '请输入正确的册号!': 'Please enter a valid register No.!',
  '请选择水表当前状态！': 'Please select the current water meter status!',
  '请选择水表用途': 'Please select water meter purpose',
  '请选择是否带阀': 'Please select whether with valve',
  '是否带阀': 'With Valve',
  '运营商': 'Carrier',
  '请选择运营商': 'Select carrier',
  'IMEI号': 'IMEI No.',
  'SIM卡号': 'SIM Card No.',
  '请输入IMEI号': 'Please enter IMEI No.',
  '请输入SIM卡号': 'Please enter SIM No.',
  '请输入机械读数': 'Please enter mechanical reading',
  '剩余金额(元)': 'Remaining Balance (CNY)',
  '请输入剩余金额': 'Please enter remaining balance',
  '请输入换表后账户剩余金额': 'Please enter remaining balance after replacement',
  '必须为数字': 'Must be a number',
  '必须为数字值': 'Must be a numeric value',
  '只允许字母、数字和横线': 'Only letters, numbers and hyphens are allowed',
  '是否收费': 'Charged',
  '收费': 'Fee Collection',
  '不收费': 'No Charge',
  '请选择是否收费': 'Select whether charged',
  '收费金额(元)': 'Charge Amount (CNY)',
  '请输入收费金额': 'Please enter charge amount',
  '付款码': 'Payment QR Code',
  '支付凭证': 'Payment Voucher',
  '请上传支付凭证': 'Please upload payment voucher',
  '协议书照片': 'Agreement Photos',
  '请上传协议书照片': 'Please upload agreement photos',
  '电子签名': 'E-Signature',
  '暂无签名': 'No signature',
  '签名': 'Signature',
  '预览': 'Preview',
  '收费信息': 'Charge Info',
  '费用已收取': 'Fee Collected',
  '费用附件': 'Fee Attachments',
  // ── 工单评价 ──
  '工单类型分类评价': 'Evaluation by Work Order Type',
  '满意度': 'Satisfaction',
  '非常不满意': 'Very Dissatisfied',
  '不满意': 'Dissatisfied',
  '一般': 'Average',
  '满意': 'Satisfied',
  '非常满意': 'Very Satisfied',
  '请选择满意度': 'Select satisfaction level',
  '评论信息': 'Comments',
  '评价': 'Evaluation',
  '查看评价': 'View Evaluation',
  // ── 工程报装（建档/详情）──
  '报装申请信息': 'Installation Application Info',
  '安装信息': 'Installation Info',
  '产权人信息': 'Property Owner Info',
  '产权人姓名': 'Property Owner Name',
  '用户身份证正反面': 'Customer ID Card (Front & Back)',
  '房产证': 'Property Certificate',
  '联系人信息': 'Contact Info',
  '联系人姓名': 'Contact Name',
  '联系人电话': 'Contact Phone',
  '营业执照': 'Business License',
  '申请主体单位信息': 'Applicant Organization Info',
  '单位名称': 'Organization Name',
  '单位地址': 'Organization Address',
  '统一社会信用代码': 'Unified Social Credit Code',
  '法人信息': 'Legal Representative Info',
  '法人姓名': 'Legal Representative Name',
  '法人身份证号码': 'Legal Representative ID Number',
  '法人身份证正反面': 'Legal Representative ID Card (Front & Back)',
  '申请公函': 'Official Application Letter',
  '单位加盖公章申请书': 'Application with Organization Seal',
  '申请用水原因及要求': 'Water Application Reason & Requirements',
  '用水地址': 'Water Use Address',
  '请输入用水地址': 'Please enter water use address',
  '用水性质': 'Water Use Category',
  '用水状态': 'Water Use Status',
  '未开始计费': 'Billing Not Started',
  '已开始计费': 'Billing Started',
  '开户时间': 'Account Opening Time',
  '用户选填信息': 'Optional Customer Info',
  '营收编号': 'Revenue No.',
  '请输入用户营收编号': 'Please enter customer revenue No.',
  '不动产权号': 'Real Estate Ownership No.',
  '请输入不动产权号': 'Please enter real estate ownership No.',
  '小区名或村庄名': 'Community or Village Name',
  '请输入用户所在小区名或村庄名': 'Please enter community or village name',
  '是否允许缴费': 'Payment Allowed',
  '请选择是否允许缴费': 'Please select whether payment is allowed',
  '优惠信息': 'Discount Info',
  '地址信息': 'Address Info',
  '请选择区域': 'Please select area',
  '请输入用户地址': 'Please enter customer address',
  '请输入水表安装地址': 'Please enter meter installation address',
  '安装经度': 'Installation Longitude',
  '安装纬度': 'Installation Latitude',
  '请输入水表安装经度': 'Please enter meter installation longitude',
  '请输入水表安装纬度': 'Please enter meter installation latitude',
  '请输入用户编号': 'Please enter customer No.',
  '请输入用户姓名': 'Please enter customer name',
  '请输入用户手机号': 'Please enter customer mobile phone',
  '请输入手机号码': 'Please enter mobile phone number',
  '请输入正确的手机号码': 'Please enter a valid mobile phone number',
  '请输入正确的身份证号': 'Please enter a valid ID number',
  '请输入用户身份证号': 'Please enter customer ID number',
  '请输入身份证号': 'Please enter ID number',
  '请选择身份类型': 'Please select identity type',
  '请输入用户名称': 'Please enter customer name',
  '请选择用户类别': 'Please select customer category',
  '请选择用户类型': 'Please select customer type',
  '请输入用户类型': 'Please enter customer type',
  '请输入用户区域id！': 'Please enter customer area ID!',
  '建档': 'Filing',
  '建档状态': 'Filing Status',
  '勘测设计信息': 'Survey & Design Info',
  '勘察相约时间': 'Survey Appointment Time',
  '勘察实际时间': 'Actual Survey Time',
  '安全状况': 'Safety Condition',
  '正常': 'Normal',
  '恶劣': 'Harsh',
  '极度恶劣': 'Extremely Harsh',
  '施工环境': 'Construction Environment',
  '日供水量(m³)': 'Daily Water Supply (m³)',
  '设计信息': 'Design Info',
  '是否排水': 'Drainage',
  '报装口径': 'Installation Caliber',
  '管线长度及规格(米)': 'Pipeline Length & Specification (m)',
  '工程预算(元)': 'Project Budget (CNY)',
  '预算信息': 'Budget Info',
  '合同名称': 'Contract Name',
  '合同金额(元)': 'Contract Amount (CNY)',
  '甲方': 'Party A',
  '乙方': 'Party B',
  '备注说明': 'Remark Description',
  '预存金额': 'Prepaid Amount',
  '合同附件': 'Contract Attachments',
  '施工信息': 'Construction Info',
  '施工备注': 'Construction Remarks',
  '是否存在设计变更': 'Design Change or Not',
  '施工附件': 'Construction Attachments',
  '验收附件': 'Acceptance Attachments',
  '录入处理信息': 'Enter Handling Info',
  '稽查核验信息': 'Inspection Info',
  '核验稽查描述': 'Verification & Inspection Description',
  '核验稽查照片': 'Verification & Inspection Photos',
  '请输入稽核查验描述': 'Please enter inspection description',
  '请选择区域名称': 'Please select area name',
  '请输入区域名称': 'Please enter area name',
}
